import { FollowUpSurveyListType } from '@nkr/enums/index';
import { IFollowUpSurveyForList } from '@nkr/models/index';
import { CenterGridWrapper } from '../../styles';
import { GridReadyEvent } from 'ag-grid-community';
import CommonList from './common-list';
import { SurveyAction } from './survey-action';

interface IProps {
    isAdminLogin: boolean,
    centerId: number,
    listType: FollowUpSurveyListType,
    list: IFollowUpSurveyForList[],
    isLoading: boolean,
    onLoadingComplete: () => void,
    onGridReady: (e: GridReadyEvent) => void,
    onItemSelected: (id: number, action: SurveyAction) => void
}

const CenterSurveyList = (props: IProps) => {
    return (
        <CenterGridWrapper className='ag-theme-bootstrap' isSurveys={true}>
            <CommonList
                list={props.list}
                listType={props.listType}
                centerId={props.centerId}
                isAdmin={false}
                isAdminLogin={props.isAdminLogin}
                isLoading={props.isLoading}
                onLoadingComplete={props.onLoadingComplete}
                onGridReady={props.onGridReady}
                onItemSelected={props.onItemSelected}
            />
        </CenterGridWrapper>
    );
}

export default CenterSurveyList;